import { modelNumberLookup, widthLookup } from './backsplashLookups';
import { BacksplashState } from './BacksplashState';

export class BacksplashSummary {
  /**
   * The current state of the backsplash.
   * @type {BacksplashState}
   */
  #state;

  /**
   * @param {BacksplashState} state
   */
  constructor(state) {
    this.#state = state;
  }

  /**
   * The backsplash model number for the summary page.
   * @returns {string}
   */
  modelNumber() {
    return `Model number: ${modelNumberLookup[this.#state.modelNumber]}`;
  }

  /**
   * The backsplash model number for the summary page.
   * @returns {string}
   */
  width() {
    return `Width: ${widthLookup[this.#state.modelNumber]}`;
  }
}
